import { render } from "./addBrand.vue?vue&type=template&id=46824690&scoped=true"
import script from "./addBrand.vue?vue&type=script&lang=js"
export * from "./addBrand.vue?vue&type=script&lang=js"

import "./addBrand.vue?vue&type=style&index=0&id=46824690&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46824690"]])

export default __exports__